module.exports = __webpack_public_path__ + "img/adhka-yx1zn.009.61fcba1a.jpeg";